<template>
  <div>
    <div class="w-full flex justify-between py-2 bg-action-bar">
      <div class="flex flex-wrap text-left">
        <div class="rounded bg-primary-300 py-1 px-3 text-white mx-2 font-bold text-sm cursor-pointer" v-bind:class="currentPageTab == 'trips' ? 'bg-primary-500' : 'hover:bg-primary-400'" @click="changeCurrentPage('trips')">
          Scheduled Trips
        </div>
        <div class="rounded bg-primary-300 py-1 px-3 text-white mx-2 font-bold text-sm cursor-pointer" v-bind:class="currentPageTab == 'fleet' ? 'bg-primary-500' : 'hover:bg-primary-400'" @click="changeCurrentPage('fleet')">
          {{ $t('fleet_management.tab_title') }}
        </div>
        <div class="rounded bg-primary-300 py-1 px-3 text-white mx-2 font-bold text-sm cursor-pointer" v-bind:class="currentPageTab == 'history_old' ? 'bg-primary-500' : 'hover:bg-primary-400'" @click="changeCurrentPage('history_old')">
          History Old
        </div>
        <div class="rounded bg-primary-300 py-1 px-3 text-white mx-2 font-bold text-sm cursor-pointer" v-bind:class="currentPageTab == 'history' ? 'bg-primary-500' : 'hover:bg-primary-400'" @click="changeCurrentPage('history')">
          History
        </div>
      </div>
      <div class="flex flex-wrap">
        <div class="select-wrapper mx-2 mt-2 lg:mt-0" v-if="type == 'customer' && units && currentPageTab === 'history_old'">
          <select class="bg-gray-100 rounded w-full text-sm text-gray-900 focus:outline-none border-b-2 border-gray-300 transition duration-500 px-1 py-1" v-model="selected_unit" @change="selectChangeFilter()">
            <option value="">{{ $t("secure_tool.all_activities") }}</option>
            <option v-for="u in units" :key="u._id" :value="u.unit_id">{{ u.name }}</option>
          </select>
        </div>
        <div class="select-wrapper mx-2 mt-2 lg:mt-0" v-if="alarmFilterOptions.length > 0">
          <!-- <select class="bg-gray-100 rounded w-full text-sm text-gray-900 focus:outline-none border-b-2 border-gray-300 transition duration-500 disabled:opacity-50 px-1 py-1" v-model="selected_alarm" @change="selectChangeFilterAlarm()" :disabled="selected_unit == '' && type == 'customer'" :readonly="selected_unit == '' && type == 'customer'">
            <option value="">{{ $t("secure_tool.all_alarms") }}</option>
            <option v-for="a in dropdown_alarms" :key="a._id" :value="a.imei_number">{{ a.unit_name }}</option>
          </select> -->
        </div>
      </div>
    </div>
    <div class="w-full mt-6">
      <div class="scheduled-trips-table-container">
        <vue-good-table
          v-if="currentPageTab === 'trips'"
          styleClass="vgt-table"
          row-style-class="text-sm"
          :columns="columns"
          :rows="activeTrips"
          :search-options="{
            enabled: false,
          }"
          :pagination-options="paginagion_params"
          :isLoading.sync="isLoading"
          @on-column-filter="onColumnFilter"
          mode="remote"
        >
          <template slot="column-filter" slot-scope="{ column, updateFilters }">
            <div class="inline-block w-60 border-separate whitespace-pre-line" v-if="column.filterOptions && column.filterOptions.customFilter">
              <div class="text-xs font-normal font-sans" v-if="column.field == 'route_name'">
                <treeselect v-model="selectedDepartments1" :options="customerDepartmentOptionsTab1" @input="(val) => onDepartmentSelect(1, val)" @close="onDepartmentsClose(1, column, updateFilters)" :beforeClearAll="() => clearAllUnits(1)" :multiple="true" value-consists-of="ALL" noChildrenText="Ingen verksamhet" />
              </div>
              <div class="text-xs font-normal font-sans" v-if="column.field == 'product_name'">
                <treeselect v-model="selectedAlarm1" :options="deviceOptionsTab1" @close="onAlarmClose(1, column, updateFilters)" :multiple="true" />
              </div>
            </div>
          </template>

          <div slot="table-actions">
            <div class="left-header">
              <span class="text-sm font-semibold text-gray-700" v-if="currentCustomerName">{{ $t('secure_route_page.secure_route') }} -  {{ currentCustomerName }}</span>
            </div>
            <div class="flex flex-wrap items-center justify-between gap-2 w-full">
              <div class="flex flex-wrap items-center gap-2">
              <div class="flex items-center gap-1">
                <date-picker
                  v-model="activeTripsDateRange"
                  type="date"
                  range
                  :lang="date_picker_lang"
                  :key="'active_' + date_picker_langKey"
                  :editable="false"
                  :clearable="false"
                  :disabled-date="disableDate"
                  @change="onActiveTripsDateRangeChange"
                  class="text-xs"
                />
              </div>
              <button class="btn-secondary-outline mx-1 mt-2 lg:mt-0" @click="resetFiltersTab1()">
                {{ $t("secure_tool.reset") }}
                <BaseIcon icon="undo" class="ml-1" />
              </button>
              <button class="btn-blue-outline mx-1 mt-2 lg:mt-0" @click="refreshData()">
                {{ $t("secure_route_page.refresh") }}
                <BaseIcon icon="sync" class="ml-1" />
              </button>
              <button class="btn-blue mx-1 mt-2 lg:mt-0" @click="createNewTrip()">
                {{ $t("secure_route_page.new_tour") }}
                <BaseIcon icon="plus" class="ml-1" />
              </button>
              </div>
            </div>
          </div>

          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'route_name'">
              <div class="flex flex-col">
                <div class="font-medium text-sm text-gray-800">
                  {{ props.row.route_name }}
                </div>
              </div>
            </span>
            <span v-else-if="props.column.field == 'product_name'">
              <!-- <span v-if="props.row.gps_last_seen" class="text-xxs last-seen mr-1" v-bind:class="{ inactive: new Date().getTime() - new Date(props.row.gps_last_seen).getTime() > 1000 * 60 * 60 }">⬤</span> -->
              <span class="text-gray-700">{{ alarmLabelMap.get(props.row.imei_number) || '' }}</span>
            </span>
            <span v-else-if="props.column.field == 'departure_time'">
              <div class="font-medium text-gray-800">{{ formatDate(props.row.departure_time) }}</div>
            </span>
            <span v-else-if="props.column.field == 'departure_expiry'">
              <template v-if="getDepartureExpiryInfo(props.row)">
                <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium" :class="getDepartureExpiryInfo(props.row).colorClass">
                  {{ getDepartureExpiryInfo(props.row).label }}
                </span>
              </template>
            </span>
            <span v-else-if="props.column.field == 'status'">
              <div class="flex items-center">
                <span v-if="props.row.trip_state && props.row.trip_state.tripStarted == false && props.row.trip_state.tripEnded == false" class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-200 text-gray-700">
                  <span class="w-2 h-2 rounded-full bg-gray-500 mr-1.5"></span>
                  {{ $t('asset_tracking_table.status_not_started') }}
                </span>
                <span v-else-if="props.row.trip_state && props.row.trip_state.tripStarted == true && props.row.trip_state.tripEnded == false" class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">
                  <span class="w-2 h-2 rounded-full bg-yellow-500 mr-1.5 animate-pulse"></span>
                  {{ $t('asset_tracking_table.status_ongoing') }}
                </span>
                <span v-else-if="props.row.trip_state && props.row.trip_state.tripStarted == true && props.row.trip_state.tripEnded == true" class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">
                  <span class="w-2 h-2 rounded-full bg-green-500 mr-1.5"></span>
                  {{ $t('asset_tracking_table.status_completed') }}
                </span>
              </div>
            </span>
            <span v-else-if="props.column.field == 'route'">
              <div class="route-display-container" @mouseenter="updatePopoverPosition" @mouseleave="hidePopover">
                <div class="route-compact">
                  <div class="route-summary-line" ref="routeSummaryLine">
                    <span class="route-info-text">
                      <template v-if="props.row.waypoints && props.row.waypoints.length > 2">
                        {{ getIntermediateWaypoints(props.row.waypoints).filter(w => w.type === 'destination').length }} {{ $t('asset_tracking_table.stops') }}, 
                        {{ getIntermediateWaypoints(props.row.waypoints).filter(w => w.type === 'break').length }} {{ $t('asset_tracking_table.breaks') }}
                        <span class="icon-bg"><base-icon icon="info" class="text-white" style="font-size: 10px;" /></span>
                      </template>
                      <template v-else>
                        {{ $t('asset_tracking_table.nonstop_trip') }}
                        <span class="icon-bg"><base-icon icon="info" class="text-white" style="font-size: 10px;" /></span>
                      </template>
                    </span>
                  </div>
                </div>

                <!-- Popover with complete route details -->
                <div class="route-popover" :style="{ left: popoverStyle.left, top: popoverStyle.top }">
                  <div class="popover-content">
                    <div class="popover-header">
                      <h4 class="font-semibold text-sm text-gray-800">{{ props.row?.route_name ? props.row?.route_name : 'Route' }}</h4>
                    </div>
                    
                    <div class="popover-body" :style="{ maxHeight: popoverStyle.maxHeight }">
                      <RoutePreviewTimeline :waypoints="props.row.waypoints" :fallbackStartAddress="props.row?.start_address" :fallbackEndAddress="props.row?.end_address"/>
                    </div>
                  </div>
                </div>
              </div>
            </span>
            <span v-else-if="props.column.field == 'distance'">
              <div class="flex flex-col">
                <div class="flex items-center text-gray-700">
                  <BaseIcon icon="road" class="text-primary-500 mr-1" style="font-size: 14px;" />
                  <span class="font-medium">{{ (props.row.total_distance / 1000).toFixed(2) }} km</span>
                </div>
                <div class="text-xs text-gray-500 mt-0.5" v-if="props.row.total_duration">
                  <BaseIcon icon="clock" style="font-size: 10px;" />
                  {{ formatDuration(props.row.total_duration) }}
                </div>
              </div>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
            <span v-if="props.column.field == 'actions'">
              <div class="flex items-center gap-1">
                <button class="btn-blue-outline px-2 py-1 text-xs" @click.prevent="planTrip(props.row)">
                  <BaseIcon :icon="props.row.trip_state && props.row.trip_state.tripStarted == false ? 'edit' : 'eye'" class="mr-1" />
                  <span v-if="props.row.trip_state && props.row.trip_state.tripStarted == false">{{ $t('edit') }}</span>
                  <span v-else>{{ $t('view') }}</span>
                </button>
                <button class="btn-blue-outline px-2 py-1 text-xs" @click.prevent="showNotificationModal(props.row)">
                  <BaseIcon icon="bell" class="mr-1" />
                  <span>{{ $t('trip_planner.settings') }}</span>
                </button>
                <button class="btn-secondary-outline px-2 py-1 text-xs" @click.prevent="showShareModal(props.row)">
                  <BaseIcon icon="share-alt" class="mr-1" />
                  {{ $t('trip_planner.share') }}
                </button>
                <button class="btn-red-outline px-2 py-1 text-xs" @click.prevent="deleteTripPrompt(props.row)">
                  <BaseIcon icon="trash"/>
                </button>
              </div>
            </span>
          </template>
        </vue-good-table>
      </div>
      <vue-good-table
        v-if="currentPageTab === 'history_old'"
        styleClass="vgt-table"
        row-style-class="text-sm"
        :columns="historyTablecolumns"
        :rows="deviceList"
        :search-options="{
          enabled: true,
        }"
        :isLoading.sync="isLoading"
        mode="remote"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'department_name'">
            {{ props.row.department_name }}
          </span>
          <span v-if="props.column.field === 'unit_name'">
            <span v-if="props.row.hasOwnProperty('isActive')">
              <span class="last-seen" v-bind:class="{ inactive: props.row.isActive, orange: !props.row.isActive }">⬤</span>
            </span>
            <span v-else>
              <span class="last-seen grey">⬤</span>
            </span>
            <span class="pl-1">{{ props.row.unit_name }}</span>
          </span>
          <span v-if="props.column.field == 'view'">
            <button class="btn-blue-outline" @click.prevent="showTrip(props.row)">
              {{ $t('view') }}
            </button>
          </span>
        </template>
      </vue-good-table>
      <div class="history-trips-table-container">
        <vue-good-table
          v-if="currentPageTab === 'history'"
          styleClass="vgt-table"
          row-style-class="text-sm"
          :columns="completedTripColumns"
          :rows="completedTrips"
          :search-options="{
            enabled: false,
          }"
          :pagination-options="paginagion_params"
          :isLoading.sync="isLoading"
          @on-column-filter="onColumnFilter"
          mode="remote"
        >
          <template slot="column-filter" slot-scope="{ column, updateFilters }">
            <div class="inline-block w-60 border-separate whitespace-pre-line" v-if="column.filterOptions && column.filterOptions.customFilter">
              <div class="text-xs font-normal font-sans" v-if="column.field == 'route_name'">
                <treeselect v-model="selectedDepartments3" :options="customerDepartmentOptionsTab3" @input="(val) => onDepartmentSelect(3, val)" @close="onDepartmentsClose(3, column, updateFilters)" :beforeClearAll="() => clearAllUnits(3)" :multiple="true" value-consists-of="ALL" noChildrenText="Ingen verksamhet" />
              </div>
              <div class="text-xs font-normal font-sans" v-if="column.field == 'product_name'">
                <treeselect v-model="selectedAlarm3" :options="deviceOptionsTab3" @close="onAlarmClose(3, column, updateFilters)" :multiple="true" />
              </div>
            </div>
          </template>

          <div slot="table-actions">
            <div class="left-header">
              <span class="text-sm font-semibold text-gray-700" v-if="currentCustomerName">{{ $t('secure_route_page.secure_route') }} -  {{ currentCustomerName }}</span>
            </div>
            <div class="flex flex-wrap items-center justify-between gap-2 w-full">
              <div class="flex flex-wrap items-center gap-2">
                <!-- Date range filter for Tab 3 -->
                <div class="flex items-center gap-1">
                  <date-picker
                    v-model="completedTripsDateRange"
                    type="date"
                    range
                    :lang="date_picker_lang"
                    :key="'completed_' + date_picker_langKey"
                    :editable="false"
                    :clearable="false"
                    :disabled-date="disableDate"
                    @change="onCompletedDateRangeChange"
                    class="text-xs"
                  />
                </div>
                <button class="btn-secondary-outline mx-1 mt-2 lg:mt-0" @click="resetFiltersTab3()">
                  {{ $t("secure_tool.reset") }}
                  <BaseIcon icon="undo" class="ml-1" />
                </button>
                <button class="btn-blue-outline mx-1 mt-2 lg:mt-0" @click="refreshData()">
                  {{ $t("secure_route_page.refresh") }}
                  <BaseIcon icon="sync" class="ml-1" />
                </button>
                <button class="btn-blue mx-1 mt-2 lg:mt-0" @click="createNewTrip()">
                  {{ $t("secure_route_page.new_tour") }}
                  <BaseIcon icon="plus" class="ml-1" />
                </button>
              </div>
            </div>
          </div>

          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'route_name'">
              <div class="flex flex-col">
                <div class="font-medium text-sm text-gray-800 mt-0.5">
                  {{ props.row.route_name }}
                </div>
              </div>
            </span>
            <span v-else-if="props.column.field == 'product_name'">
              <!-- <span v-if="props.row.gps_last_seen" class="text-xxs last-seen mr-1" v-bind:class="{ inactive: new Date().getTime() - new Date(props.row.gps_last_seen).getTime() > 1000 * 60 * 60 }">⬤</span> -->
              <span class="text-gray-700">{{ alarmLabelMap.get(props.row.imei_number) || '' }}</span>
            </span>
            <span v-else-if="props.column.field == 'departure_time'">
              <div class="font-medium text-gray-800">{{ formatDate(props.row.departure_time) }}</div>
            </span>
            <span v-else-if="props.column.field == 'status'">
              <div class="flex items-center">
                <span v-if="props.row.trip_state && props.row.trip_state.tripStarted == false && props.row.trip_state.tripEnded == false" class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-200 text-gray-700">
                  <span class="w-2 h-2 rounded-full bg-gray-500 mr-1.5"></span>
                  {{ $t('asset_tracking_table.status_not_started') }}
                </span>
                <span v-else-if="props.row.trip_state && props.row.trip_state.tripStarted == true && props.row.trip_state.tripEnded == false" class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">
                  <span class="w-2 h-2 rounded-full bg-yellow-500 mr-1.5 animate-pulse"></span>
                  {{ $t('asset_tracking_table.status_ongoing') }}
                </span>
                <span v-else-if="props.row.trip_state && props.row.trip_state.tripStarted == true && props.row.trip_state.tripEnded == true" class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">
                  <span class="w-2 h-2 rounded-full bg-green-500 mr-1.5"></span>
                  {{ $t('asset_tracking_table.status_completed') }}
                </span>
              </div>
            </span>
            <span v-else-if="props.column.field == 'route'">
              <div class="route-display-container" @mouseenter="updatePopoverPosition" @mouseleave="hidePopover">
                <div class="route-compact">
                  <div class="route-summary-line" ref="routeSummaryLine">
                    <span class="route-info-text">
                      <template v-if="props.row.waypoints && props.row.waypoints.length > 2">
                        {{ getIntermediateWaypoints(props.row.waypoints).filter(w => w.type === 'destination').length }} {{ $t('asset_tracking_table.stops') }}, 
                        {{ getIntermediateWaypoints(props.row.waypoints).filter(w => w.type === 'break').length }} {{ $t('asset_tracking_table.breaks') }}
                        <span class="icon-bg"><base-icon icon="info" class="text-white" style="font-size: 10px;" /></span>
                      </template>
                      <template v-else>
                        {{ $t('asset_tracking_table.nonstop_trip') }}
                        <span class="icon-bg"><base-icon icon="info" class="text-white" style="font-size: 10px;" /></span>
                      </template>
                    </span>
                  </div>
                </div>

                <!-- Popover with complete route details -->
                <div class="route-popover" :style="{ left: popoverStyle.left, top: popoverStyle.top }">
                  <div class="popover-content">
                    <div class="popover-header">
                      <h4 class="font-semibold text-sm text-gray-800">{{ props.row?.route_name ? props.row?.route_name : 'Route' }}</h4>
                    </div>
                    
                    <div class="popover-body" :style="{ maxHeight: popoverStyle.maxHeight }">
                      <RoutePreviewTimeline :waypoints="props.row.waypoints" :fallbackStartAddress="props.row?.start_address" :fallbackEndAddress="props.row?.end_address"/>
                    </div>
                  </div>
                </div>
              </div>
            </span>
            <span v-else-if="props.column.field == 'distance'">
              <div class="flex flex-col">
                <div class="flex items-center text-gray-700">
                  <BaseIcon icon="road" class="text-primary-500 mr-1" style="font-size: 14px;" />
                  <span class="font-medium">{{ (props.row.total_distance / 1000).toFixed(2) }} km</span>
                </div>
                <div class="text-xs text-gray-500 mt-0.5" v-if="props.row.total_duration">
                  <BaseIcon icon="clock" style="font-size: 10px;" />
                  {{ formatDuration(props.row.total_duration) }}
                </div>
              </div>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
            <span v-if="props.column.field == 'actions'">
              <div class="flex items-center gap-1">
                <button class="btn-blue-outline px-2 py-1 text-xs" @click.prevent="showTrip2(props.row)">
                  <BaseIcon icon="eye" class="mr-1" />
                  <span>{{ $t('view') }}</span>
                </button>
                <button class="btn-blue-outline px-2 py-1 text-xs" @click.prevent="showNotificationModal(props.row)">
                  <BaseIcon icon="bell" class="mr-1" />
                  <span>{{ $t('trip_planner.settings') }}</span>
                </button>
                <button class="btn-red-outline px-2 py-1 text-xs" @click.prevent="deleteTripPrompt(props.row)">
                  <BaseIcon icon="trash"/>
                </button>
              </div>
            </span>
          </template>
        </vue-good-table>
      </div>

      <!-- Fleet Management Tab -->
      <div class="fleet-management-table-container" v-if="currentPageTab === 'fleet'">
        <vue-good-table
          styleClass="vgt-table"
          row-style-class="text-sm"
          :columns="fleetColumns"
          :rows="fleetVehicles"
          :search-options="{ enabled: false }"
          :isLoading.sync="isFleetLoading"
        >
          <div slot="table-actions">
            <div class="left-header">
              <span class="text-sm font-semibold text-gray-700" v-if="currentCustomerName">{{ $t('fleet_management.tab_title') }} - {{ currentCustomerName }}</span>
            </div>
            <div class="flex flex-wrap items-center gap-2">
              <button class="btn-blue-outline mx-1 mt-2 lg:mt-0" @click="getFleetVehicles">
                {{ $t('secure_route_page.refresh') }}
                <BaseIcon icon="sync" class="ml-1" />
              </button>
              <button class="btn-secondary-outline mx-1 mt-2 lg:mt-0" @click="openBrandManagerModal">
                <BaseIcon icon="cog" class="mr-1" />
                {{ $t('fleet_management.manage_brands') }}
              </button>
              <button class="btn-blue mx-1 mt-2 lg:mt-0" @click="openCreateCarModal">
                {{ $t('fleet_management.create_car') }}
                <BaseIcon icon="plus" class="ml-1" />
              </button>
            </div>
          </div>

          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'car_name'">
              <div class="flex items-center gap-2">
                <span class="inline-flex items-center justify-center w-7 h-7 rounded-full bg-primary-100">
                  <BaseIcon icon="car" class="text-primary-600" style="font-size: 12px;" />
                </span>
                <span class="font-medium text-gray-800">{{ props.row.car_name }}</span>
              </div>
            </span>
            <span v-else-if="props.column.field === 'brand_model'">
              <div class="flex flex-col leading-tight">
                <span class="font-medium text-gray-700 text-xs">{{ props.row.car_brand || '—' }}</span>
                <span class="text-gray-500 text-xs">{{ props.row.car_model || '' }}</span>
              </div>
            </span>
            <span v-else-if="props.column.field === 'license_plate'">
              <span v-if="props.row.license_plate" class="inline-flex items-center px-2 py-0.5 rounded text-xs font-mono font-semibold bg-gray-100 border border-gray-300 text-gray-800">
                {{ props.row.license_plate }}
              </span>
              <span v-else class="text-gray-400 text-xs">—</span>
            </span>
            <span v-else-if="props.column.field === 'fuel_type'">
              <span v-if="props.row.fuel_type" class="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full font-medium"
                :class="{
                  'bg-blue-50 text-blue-700': props.row.fuel_type === 'electric',
                  'bg-green-50 text-green-700': props.row.fuel_type === 'hybrid',
                  'bg-gray-100 text-gray-700': props.row.fuel_type === 'petrol' || props.row.fuel_type === 'diesel',
                  'bg-yellow-50 text-yellow-700': props.row.fuel_type === 'gas',
                }">
                {{ $t('fleet_management.fuel_' + props.row.fuel_type) }}
              </span>
              <span v-else class="text-gray-400 text-xs">—</span>
            </span>
            <span v-else-if="props.column.field === 'service_interval_miles'">
              <span v-if="props.row.service_interval_miles" class="text-xs text-gray-700">
                {{ props.row.service_interval_miles.toLocaleString() }} km
              </span>
              <span v-else class="text-gray-400 text-xs">—</span>
            </span>
            <span v-else-if="props.column.field === 'device_name'">
              <span v-if="props.row.device_name" class="inline-flex items-center gap-1 text-gray-700 text-xs">
                <BaseIcon icon="satellite-dish" class="text-primary-500" style="font-size: 11px;" />
                {{ props.row.device_name }}
              </span>
              <span v-else class="text-gray-400 text-xs">{{ $t('fleet_management.no_device') }}</span>
            </span>
            <span v-else-if="props.column.field === 'createdAt'">
              {{ formatDate(props.row.createdAt) }}
            </span>
            <span v-else-if="props.column.field === 'actions'">
              <div class="flex items-center gap-1">
                <button class="btn-blue-outline px-2 py-1 text-xs" @click.prevent="openEditCarModal(props.row)">
                  <BaseIcon icon="edit" class="mr-1" />
                  {{ $t('edit') }}
                </button>
                <button class="btn-red-outline px-2 py-1 text-xs" @click.prevent="deleteFleetVehiclePrompt(props.row)">
                  <BaseIcon icon="trash" />
                </button>
              </div>
            </span>
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
          </template>
        </vue-good-table>
      </div>
    </div>

    <TripReport ref="tripReportModal" :gpss="gpss_data" :updateInfo="updateInfo" @on-unit-select="filterUnit" @routeSaved="getAlarmTrips" />
    <TripHistory ref="tripHistoryModal" />
    <TripHistory3 ref="tripHistoryModal2" />
    <NotificationSetting ref="notificationSettingModal" @settings-updated="onNotificationSettingsUpdated" />
    <TripShareModal ref="tripShareModal" @trip-shared="onTripShared" />
    <FleetCarModal ref="fleetCarModal" @saved="getFleetVehicles" />
    <FleetBrandModal ref="fleetBrandModal" />
  </div>
</template>

<script>
import TripReport from "@/components/map/secure_route/TripReport";
import TripHistory from "@/components/map/secure_route/TripHistory";
import TripHistory3 from "@/components/map/secure_route/TripHistory3";
import NotificationSetting from "@/components/modal/secure_route/assets_tracker_notification_settings";
import TripShareModal from "@/components/modal/secure_route/trip_share_modal.vue";
import FleetCarModal from "@/components/modal/secure_route/fleet_car_modal.vue";
import FleetBrandModal from "@/components/modal/secure_route/fleet_brand_modal.vue";
//import tooltip from "@/components/base/tooltip";
import RoutePreviewTimeline from "@/components/secure_route/route_preview_timeline";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/sv";
import "vue2-datepicker/locale/pl";
import "@/utils/datePickerDutch";
import "vue2-datepicker/index.css";

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  title() {
    return this.$t("secure_route_page.title");
  },

  components: {
    TripReport,
    TripHistory,
    TripHistory3,
    DatePicker,
    Treeselect,
    NotificationSetting,
    TripShareModal,
    RoutePreviewTimeline,
    FleetCarModal,
    FleetBrandModal,
  },

  data() {
    return {
      zoom: this.$store.state.mapZoom,
      center: this.$store.state.mapCenter,
      imei: this.$route.params.imei,
      user: this.$store.state.user,
      type: this.$route.params.type,
      isLoading: false,
      currentPageTab: 'trips',
      selected_unit: "",
      selected_alarm: "",
      date_picker_lang: "en",
      date_picker_langKey: 0,
      trips: [],
      completedTrips: [],
      activeTrips: [],
      deviceList: [],
      units: [],
      gpss_data: [],
      alarmFilterOptions: [],
      allAlarmFilterOptions: [],
      alarmList: [],
      deptWiseDevices: {},
      deviceOptionsTab1: [],
      deviceOptionsTab3: [],
      customerDepartmentOptionsTab1: [],
      customerDepartmentOptionsTab3: [],
      // Tab 1 filter state
      selectedDepartments1: [],
      lastAppliedDepartments1: [],
      selectedAlarm1: [],
      lastAppliedAlarm1: [],
      // Tab 3 filter state
      selectedDepartments3: [],
      lastAppliedDepartments3: [],
      selectedAlarm3: [],
      lastAppliedAlarm3: [],
      selectedUnits: [],
      deviceFilter: [],
      deviceOption: [],
      customers: [],
      updateInfo: [],
      popoverStyle: {},
      hidePopoverTimeout: null,
      customerNameFilter: '',
      activeTripsDateRange: [
        new Date('2025-10-01'),
        new Date(this.moment().endOf('day')),
      ],
      completedTripsDateRange: [
        new Date(this.moment().subtract(3, 'months').startOf('day')),
        new Date(this.moment().endOf('day')),
      ],
      server_params_completed: {
        startDate: this.moment().subtract(3, 'months').startOf('day').toISOString(),
        endDate: this.moment().endOf('day').toISOString(),
        sort: [{ field: 'createdAt', type: 'desc' }],
        page: 1,
        perPage: 100,
        filters: {
          unit_id: [],
          imei_number: [],
        },
      },
      server_params: {
        filters: {
          unit_id: [],
          imei_number: [],
        },
        startDate: '2025-10-01T00:00:00.000Z',
        endDate: this.moment().endOf('day').toISOString(),
        sort: [{ field: "createdAt", type: "desc" }],
        page: 1,
        perPage: 100,
      },
      paginagion_params: {
        enabled: true,
        position: "bottom",
        mode: "pages",
        jumpFirstOrLast: true,
        perPage: 100,
        perPageDropdown: [500, 1000, 1500],
        dropdownAllowAll: false,
        pageLabel: "page",
        rowsPerPageLabel: "per page",
      },
      // Fleet Management
      fleetVehicles: [],
      isFleetLoading: false,
    };
  },
  computed: {
    currentCustomerName() {
      const customer = this.customers.find(c => c.customer_id == this.$route.params.id);
      return customer ? customer.name : '';
    },
    alarmLabelMap() {
      return new Map(this.allAlarmFilterOptions.map(a => [a.id, a.label]));
    },
    columns() {
      return [
        { label: this.$t("asset_tracking_table.route_name"), field: "route_name", sortable: false, filterOptions: { enabled: true, customFilter: true }, width: '200px' },
        { label: this.$t("asset_tracking_table.alarm"), field: "product_name", sortable: false, filterOptions: { enabled: true, customFilter: true }, width: '140px' },
        { label: this.$t("asset_tracking_table.route"), field: "route", sortable: false, width: '150px' },
        { label: this.$t("asset_tracking_table.distance"), field: "distance", sortable: false, width: '100px' },
        { label: this.$t("asset_tracking_table.departure_time"), field: "departure_time", sortable: false, width: '150px' },
        { label: this.$t("asset_tracking_table.dep_status"), field: "departure_expiry", sortable: false, width: '120px' },
        { label: this.$t("asset_tracking_table.date"), field: "createdAt", formatFn: this.formatDate, width: '100px' },
        { label: this.$t("asset_tracking_table.status"), field: "status", width: '140px' },
        { label: "", field: "actions", sortable: false, width: '300px' },
      ];
    },
    completedTripColumns() {
      return [
        { label: this.$t("asset_tracking_table.route_name"), field: "route_name", sortable: false, filterOptions: { enabled: true, customFilter: true }, width: '200px' },
        { label: this.$t("asset_tracking_table.alarm"), field: "product_name", sortable: false, filterOptions: { enabled: true, customFilter: true }, width: '160px' },
        { label: this.$t("asset_tracking_table.route"), field: "route", sortable: false, width: '150px' },
        { label: this.$t("asset_tracking_table.distance"), field: "distance", sortable: false, width: '100px' },
        { label: this.$t("asset_tracking_table.departure_time"), field: "departure_time", sortable: false, width: '150px' },
        { label: this.$t("asset_tracking_table.date"), field: "createdAt", formatFn: this.formatDate, width: '100px' },
        { label: this.$t("asset_tracking_table.status"), field: "status", width: '140px' },
        { label: "", field: "actions", sortable: false, width: '300px' },
      ];
    },
    historyTablecolumns() {
      return [
        { label: this.$t("asset_tracking_table.customer_name"), field: "department_name", sortable: true },
        { label: this.$t("asset_tracking_table.product_name"), field: "unit_name", sortable: true },
        { label: "", field: "view", sortable: false },
      ];
    },
    fleetColumns() {
      return [
        { label: this.$t('fleet_management.col_car_name'), field: 'car_name', sortable: true, width: '180px' },
        { label: this.$t('fleet_management.col_brand_model'), field: 'brand_model', sortable: false, width: '160px' },
        { label: this.$t('fleet_management.col_license_plate'), field: 'license_plate', sortable: true, width: '130px' },
        { label: this.$t('fleet_management.col_fuel_type'), field: 'fuel_type', sortable: false, width: '110px' },
        { label: this.$t('fleet_management.col_service_interval'), field: 'service_interval_miles', sortable: false, width: '130px' },
        { label: this.$t('fleet_management.col_linked_device'), field: 'device_name', sortable: false, width: '160px' },
        { label: this.$t('asset_tracking_table.date'), field: 'createdAt', sortable: true, width: '140px' },
        { label: '', field: 'actions', sortable: false, width: '130px' },
      ];
    },
  },
  methods: {
    updatePopoverPosition(event) {
      // Clear any pending hide timeout
      if (this.hidePopoverTimeout) {
        clearTimeout(this.hidePopoverTimeout);
      }
      
      this.$nextTick(() => {
        const element = event.target.closest('.route-display-container');
        if (!element) return;
        
        const pill = element.querySelector('.route-summary-line');
        const anchorRect = pill ? pill.getBoundingClientRect() : element.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        const popoverWidth = 420;
        const popoverEstimatedHeight = 420;
        const paddingRight = 20;
        const paddingLeft = 12;
        const screenPadding = 16;
        
        // Position flush to the right of the pill
        let left = anchorRect.right + paddingRight;
        
        // If it goes off-screen on the right, position on the left of the pill
        if (left + popoverWidth > window.innerWidth - screenPadding) {
          left = anchorRect.left - popoverWidth - paddingLeft;
        }
        
        // Ensure minimum left position
        if (left < screenPadding) {
          left = screenPadding;
        }
        
        // Vertically center the popover relative to the hovered row element
        let top = elementRect.top + (elementRect.height / 2) - (popoverEstimatedHeight / 2);
        
        // Clamp to top of screen
        if (top < screenPadding) {
          top = screenPadding;
        }
        
        // Clamp to bottom of screen
        if (top + popoverEstimatedHeight > window.innerHeight - screenPadding) {
          top = window.innerHeight - popoverEstimatedHeight - screenPadding;
        }
        
        // Calculate max height based on remaining space below top position
        const maxHeight = Math.min(650, window.innerHeight - top - screenPadding);
        
        this.popoverStyle = {
          left: Math.round(left) + 'px',
          top: Math.round(top) + 'px',
          maxHeight: maxHeight + 'px',
        };
      });
    },
    hidePopover() {
      this.hidePopoverTimeout = setTimeout(() => {
        this.popoverStyle = {};
      }, 300);
    },

    onCompletedDateRangeChange(dateRange) {
      if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
        this.server_params_completed.startDate = this.moment(dateRange[0]).startOf('day').toISOString();
        this.server_params_completed.endDate = this.moment(dateRange[1]).endOf('day').toISOString();
        this.server_params_completed.page = 1;
        this.getCompletedTrips();
      }
    },
    onActiveTripsDateRangeChange(dateRange) {
      if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
        this.server_params.startDate = this.moment(dateRange[0]).startOf('day').toISOString();
        this.server_params.endDate = this.moment(dateRange[1]).endOf('day').toISOString();
        this.server_params.page = 1;
        this.getAlarmTrips();
      }
    },
    getAlarmTrips() {
      const URL = `${process.env.VUE_APP_SERVER_URL}/asset-tracker/trips/${this.$route.params.id}`;
      //const URL = `${process.env.VUE_APP_SERVER_URL}/asset-tracker/trips`;

      this.isLoading = true;
      this.axios
        .post(URL, this.server_params)
        .then((response) => {
          this.isLoading = false;

          this.trips     = response.data.trips;
          this.customers = response.data.customers;
          this.gpss_data = response.data.gpss;

          this.$store.commit("SET_GPS_DATA", this.gpss_data);

          this.deviceList = response.data.deviceList || [];
          this.setDeviceStatus();

          this.activeTrips = this.trips.filter(t => !(t.trip_state && t.trip_state.tripStarted && t.trip_state.tripEnded));

          this.getTripFilterOptions();
        })
        .catch((error) => {
          this.isLoading = false;
          this.handleError(error);
        });
    },
    getCompletedTrips() {
      const URL = `${process.env.VUE_APP_SERVER_URL}/asset-tracker/completed-trips/${this.$route.params.id}`;
      this.isLoading = true;
      this.axios
        .post(URL, this.server_params_completed)
        .then((response) => {
          this.isLoading = false;

          this.completedTrips = response.data.trips;
        })
        .catch((error) => {
          this.isLoading = false;
          this.handleError(error);
        });
    },
    getTripFilterOptions() {
      const customerId = this.$route.params.id;
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/asset-tracker/filter-options/${customerId}`)
        .then((response) => {
          const unitOptions         = response.data.unitOptions         || [];
          const customerDeptOptions = response.data.customerDeptOptions || [];
          const deptWiseDevices     = response.data.deptWiseDevices     || {};

          // 1. Department filter — independent flat list (depts with at least one device)
          this.customerDepartmentOptionsTab1 = customerDeptOptions;
          this.customerDepartmentOptionsTab3 = customerDeptOptions;

          // 2. Dept-wise device map — master lookup for reactive dept filtering
          this.deptWiseDevices = deptWiseDevices;
          const flatDevices = Object.values(deptWiseDevices).flat();

          // Respect currently selected departments — don't reset if a filter is active
          this.deviceOptionsTab1 = this.selectedDepartments1.length > 0
            ? this.selectedDepartments1.flatMap(id => deptWiseDevices[id] || [])
            : flatDevices;
          this.deviceOptionsTab3 = this.selectedDepartments3.length > 0
            ? this.selectedDepartments3.flatMap(id => deptWiseDevices[id] || [])
            : flatDevices;

          // 3. alarmLabelMap source (product_name column display)
          this.allAlarmFilterOptions = flatDevices;
          this.alarmFilterOptions    = flatDevices;

          // 4. Modal device-picker tree — independent SET_UNIT_OPTIONS
          this.$store.commit('SET_UNIT_OPTIONS', unitOptions);
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    deleteTripPrompt(trip) {
      this.$modal.show("dialog", {
        title: `<span class="font-normal text-sm">${this.$t('asset_tracking_table.delete_trip_title', { start: trip.start_address, end: trip.end_address })}</span>`,
        buttons: [
          {
            title: `<div class="bg-accent-500 text-white text-sm font-sans py-2">${this.$t('asset_tracking_table.cancel')}</div>`,
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
          {
            title: `<div class="bg-red-500 text-white text-sm font-sans py-2">${this.$t('asset_tracking_table.delete')}</div>`,
            handler: () => {
              this.deleteTrip(trip._id, trip.imei_number);
            },
          },
        ],
      });
    },
    updateFilters() {
      //console.log("🚀 ~ file: trip_report.vue:378 ~ updateFilters ~ value:", value);
      //console.log("🚀 ~ file: trip_report.vue:378 ~ updateFilters ~ params:", params);
    },
    beforeClearAll() {
      //console.log("🚀 ~ beforeClearAll ");
    },
    onDepartmentsClose(tab, column, updateFilters) {
      const sel  = tab === 1 ? this.selectedDepartments1  : this.selectedDepartments3;
      const last = tab === 1 ? this.lastAppliedDepartments1 : this.lastAppliedDepartments3;
      const current = JSON.stringify(sel || []);
      const prev    = JSON.stringify(last || []);
      if (current !== prev) {
        if (tab === 1) this.lastAppliedDepartments1 = [...(sel || [])];
        else           this.lastAppliedDepartments3 = [...(sel || [])];
        updateFilters(column, sel);
      }
    },
    onAlarmClose(tab, column, updateFilters) {
      const sel  = tab === 1 ? this.selectedAlarm1  : this.selectedAlarm3;
      const last = tab === 1 ? this.lastAppliedAlarm1 : this.lastAppliedAlarm3;
      const current = JSON.stringify(sel || []);
      const prev    = JSON.stringify(last || []);
      if (current !== prev) {
        if (tab === 1) this.lastAppliedAlarm1 = [...(sel || [])];
        else           this.lastAppliedAlarm3 = [...(sel || [])];
        updateFilters(column, sel);
      }
    },
    onDepartmentSelect(tab, selectedIds) {
      const ids = selectedIds || [];
      if (tab === 1) {
        this.selectedAlarm1 = [];
        this.deviceOptionsTab1 = ids.length > 0
          ? ids.flatMap(id => this.deptWiseDevices[id] || [])
          : Object.values(this.deptWiseDevices).flat();
      } else {
        this.selectedAlarm3 = [];
        this.deviceOptionsTab3 = ids.length > 0
          ? ids.flatMap(id => this.deptWiseDevices[id] || [])
          : Object.values(this.deptWiseDevices).flat();
      }
    },
    onColumnFilter() {
      this.alarmList = [];
      if (this.currentPageTab === 'history') {
        this.server_params_completed.filters.unit_id     = this.selectedDepartments3 || [];
        this.server_params_completed.filters.imei_number = this.selectedAlarm3        || [];
        this.server_params_completed.page = 1;
        this.getCompletedTrips();
      } else {
        this.server_params.filters.unit_id     = this.selectedDepartments1 || [];
        this.server_params.filters.imei_number = this.selectedAlarm1        || [];
        this.server_params.page = 1;
        this.getAlarmTrips();
      }
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    clearAllUnits(tab = 1) {
      const allFlat = Object.values(this.deptWiseDevices).flat();
      if (tab === 1) {
        this.server_params.filters.unit_id = [];
        this.server_params.page = 1;
        this.selectedDepartments1 = [];
        this.selectedAlarm1 = [];
        this.selectedUnits = [];
        this.deviceOptionsTab1 = allFlat;
        this.getAlarmTrips();
      } else {
        this.server_params_completed.filters.unit_id = [];
        this.server_params_completed.page = 1;
        this.selectedDepartments3 = [];
        this.selectedAlarm3 = [];
        this.deviceOptionsTab3 = allFlat;
        this.getCompletedTrips();
      }
    },
    refreshData() {
      if (this.currentPageTab === 'history') {
        this.getCompletedTrips();
      } else {
        this.getAlarmTrips();
      }
    },
    filterUnit(data) {
      if (data.length > 0) {
        this.server_params.filters.unit_id = data;
        this.server_params.page = 1;
        this.selectedUnits = data;
        this.getAlarmTrips();
      }
    },
    async deleteTrip(id,imei) {
      try {
        // eslint-disable-next-line
        let response = await this.axios.delete(`${process.env.VUE_APP_SERVER_URL}/asset-tracker/trip/${id}/${imei}`);

        this.getAlarmTrips();
        this.$modal.hide("dialog");
        this.handleSuccess(this.$t('asset_tracking_table.trip_deleted'));
      } catch (error) {
        this.$modal.hide("dialog");
        this.handleError(error);
      }
    },
    createNewTrip() {
      this.updateInfo = null;
      this.$refs.tripReportModal.initDate();
      this.$refs.tripReportModal.isAlarmSelectDisabled = false;

      this.$modal.show("modal-trip-tracker");
    },
    showTrip(trip) {
      //console.log("🚀 ~ showTrip ~ trip:", trip);
      this.$refs.tripHistoryModal.setupModal(trip);
      this.$modal.show("modal-trip-history");
    },
    showTrip2(trip) {
      //console.log("🚀 ~ showTrip ~ trip:", trip);
      this.$refs.tripHistoryModal2.setupModal(trip);
      this.$modal.show("modal-trip-history2");
    },
    planTrip(trip) {
      var vm = this;
      this.updateInfo = trip;
      this.$nextTick().then(() => {
        vm.$refs.tripReportModal.setupTripInfo();
      });
      this.$modal.show("modal-trip-tracker");
    }, 
    showNotificationModal(trip) {
      this.$refs.notificationSettingModal.setupModal(trip);
      this.$modal.show("modal-asset-tracker-notification-setting");
    },
    showShareModal(trip) {
      this.$refs.tripShareModal.setupModal(trip);
      this.$modal.show("modal-trip-share");
    },
    onTripShared(data) {
      console.log('Trip shared:', data);
      // Optionally refresh trips or update UI
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.handleSuccess('Trip details copied to clipboard');
        }).catch(() => {
          this.handleError('Failed to copy to clipboard');
        });
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          this.handleSuccess('Trip details copied to clipboard');
        } catch (err) {
          this.handleError('Failed to copy to clipboard');
        }
        document.body.removeChild(textArea);
      }
    },
    onNotificationSettingsUpdated(updatedTrip) {
      // Update the trip in the trips array
      const index = this.trips.findIndex(t => t._id === updatedTrip._id);
      if (index !== -1) {
        this.$set(this.trips, index, { ...this.trips[index], ...updatedTrip });
      }
      // // Optionally refresh all trips
      this.getAlarmTrips();
    },
    formatDuration(seconds) {
      return this.moment.duration(seconds, "seconds").humanize();
    },
    formatDate(date) {
      return this.moment(date)
        .tz("Europe/Stockholm")
        .format("YYYY-MM-DD, HH:mm");
    },
    formatTime(time) {
      const m = Math.floor(time / 60);
      const s = Math.floor((time % 3600) % 60);
      const minutes = m < 9 ? "0" + m : m;
      return minutes + ":" + s;
    },
    formatDistance(meter) {
      if (meter) {
        return (meter / 1000).toFixed(2) + " Km";
      } else {
        return "0Km";
      }
    },
    getIntermediateWaypoints(waypoints) {
      // Get all waypoints between start and end (excluding first and last)
      if (!waypoints || waypoints.length <= 2) {
        return [];
      }
      
      // const intermediate = waypoints.slice(1, -1);
      const intermediate = waypoints.slice(1, -1);
      let stopNumber = 1;
      
      // Add stop numbers to destination waypoints
      return intermediate.map(waypoint => {
        if (waypoint.type === 'destination') {
          return {
            ...waypoint,
            stopNumber: stopNumber++
          };
        }
        return waypoint;
      });
    },
    selectCurrentWeek(emit) {
      const start = new Date(this.moment().startOf("isoWeek"));
      const end = new Date(this.moment().endOf("day"));
      const date = [start, end];
      emit(date);
    },
    selectLastWeek(emit) {
      const start = new Date(
        this.moment()
          .subtract(1, "weeks")
          .startOf("isoWeek")
      );
      const end = new Date(
        this.moment()
          .subtract(1, "weeks")
          .endOf("isoWeek")
      );
      const date = [start, end];
      emit(date);
    },
    selectCurrentMonth(emit) {
      const start = new Date(this.moment().startOf("month"));
      const end = new Date(this.moment().endOf("day"));
      const date = [start, end];
      emit(date);
    },

    disableDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    selectToday(emit) {
      const start = new Date(this.moment().startOf("day"));
      const end = new Date(this.moment().endOf("day"));
      const date = [start, end];
      emit(date);
    },
    resetFiltersTab1() {
      this.server_params = {
        filters: {
          unit_id: [],
          imei_number: [],
        },
        startDate: '2025-10-01T00:00:00.000Z',
        endDate: this.moment().endOf('day').toISOString(),
        sort: [{ field: 'createdAt', type: 'desc' }],
        page: 1,
        perPage: 100,
      };
      this.activeTripsDateRange = [
        new Date('2025-10-01'),
        new Date(this.moment().endOf('day')),
      ];
      this.alarmList = [];
      this.selectedDepartments1 = [];
      this.lastAppliedDepartments1 = [];
      this.selectedAlarm1 = [];
      this.lastAppliedAlarm1 = [];
      this.selectedUnits = [];
      this.getAlarmTrips();
    },
    resetFiltersTab3() {
      this.server_params_completed = {
        startDate: this.moment().subtract(3, 'months').startOf('day').toISOString(),
        endDate: this.moment().endOf('day').toISOString(),
        sort: [{ field: 'createdAt', type: 'desc' }],
        page: 1,
        perPage: 100,
        filters: {
          unit_id: [],
          imei_number: [],
        },
      };
      this.completedTripsDateRange = [
        new Date(this.moment().subtract(3, 'months').startOf('day')),
        new Date(this.moment().endOf('day')),
      ];
      this.alarmList = [];
      this.selectedDepartments3 = [];
      this.lastAppliedDepartments3 = [];
      this.selectedAlarm3 = [];
      this.lastAppliedAlarm3 = [];
      this.selectedUnits = [];
      this.getCompletedTrips();
    },
    setDeviceStatus() {
      for (let i = 0; i < this.deviceList.length; i++) {
        this.gpss_data.forEach((item) => {
          if (this.deviceList[i].imei_number === item.imei_number) {
            let thisMoment = this.moment(item.updatedAt);
            let now = this.moment();
            // Calculate the difference in minutes
            let differenceInMinutes = now.diff(thisMoment, "minutes");
            // Check if the difference is within 60 minutes (1 hour)
            if (differenceInMinutes >= 0 && differenceInMinutes <= 60) {
              // Device was updated within the last hour
              this.deviceList[i].isActive = true;
            } else {
              this.deviceList[i].isActive = false;
            }
          }
        });
      }
    },

    getDepartureExpiryInfo(trip) {
      if (!trip.departure_time) return null;
      // Don't show for trips that have already started
      if (trip.trip_state && trip.trip_state.tripStarted) return null;

      const now = this.moment();
      const dep = this.moment(trip.departure_time);
      const diffMinutes = dep.diff(now, 'minutes');
      const diffHours   = dep.diff(now, 'hours');
      const diffDays    = dep.diff(now, 'days');

      if (diffMinutes < 0) {
        // Past departure time — overdue
        return { label: this.$t('asset_tracking_table.dep_overdue'), colorClass: 'bg-red-100 text-red-700' };
      } else if (diffMinutes < 120) {
        // Within 2 hours
        return { label: `${diffMinutes}m`, colorClass: 'bg-orange-100 text-orange-700' };
      } else if (diffHours < 24) {
        // Same day, more than 2h away
        return { label: `${diffHours}h`, colorClass: 'bg-yellow-100 text-yellow-700' };
      } else {
        // More than a day away
        return { label: `${diffDays + 1}d`, colorClass: 'bg-blue-50 text-blue-600' };
      }
    },
    changeCurrentPage(value) {
      this.currentPageTab = value;
      if (value === 'fleet') {
        this.getFleetVehicles();
      }
    },
    // Fleet Management methods
    getFleetVehicles() {
      const customerId = this.$route.params.id;
      this.isFleetLoading = true;
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/fleet-vehicles/${customerId}`)
        .then((response) => {
          this.fleetVehicles = response.data.vehicles || [];
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => {
          this.isFleetLoading = false;
        });
    },
    openCreateCarModal() {
      this.$refs.fleetCarModal.openCreate();
    },
    openEditCarModal(vehicle) {
      this.$refs.fleetCarModal.openEdit(vehicle);
    },
    openBrandManagerModal() {
      this.$refs.fleetBrandModal.open();
    },
    deleteFleetVehiclePrompt(vehicle) {
      this.$modal.show('dialog', {
        title: `<span class="font-normal text-sm">${this.$t('fleet_management.delete_confirm', { name: vehicle.car_name })}</span>`,
        buttons: [
          {
            title: `<div class="bg-accent-500 text-white text-sm font-sans py-2">${this.$t('asset_tracking_table.cancel')}</div>`,
            handler: () => { this.$modal.hide('dialog'); },
          },
          {
            title: `<div class="bg-red-500 text-white text-sm font-sans py-2">${this.$t('asset_tracking_table.delete')}</div>`,
            handler: () => { this.deleteFleetVehicle(vehicle._id); },
          },
        ],
      });
    },
    async deleteFleetVehicle(id) {
      try {
        await this.axios.delete(`${process.env.VUE_APP_SERVER_URL}/fleet-vehicles/${id}`);
        this.$modal.hide('dialog');
        this.handleSuccess(this.$t('fleet_management.car_deleted'));
        this.getFleetVehicles();
      } catch (error) {
        this.$modal.hide('dialog');
        this.handleError(error);
      }
    },
  },
  created() {
    //console.log("moment=> ", this.moment().toDate());
  },
  mounted() {
    this.getAlarmTrips();
    this.$store.commit("SET_PAGE_TITLE", this.$t("secure_route_page.title"));
    this.getCompletedTrips();
  },
  watch: {
    "$i18n.locale"(newLocale) {
      document.title = this.$t("secure_route_page.title");
      this.$store.commit("SET_PAGE_TITLE", this.$t("secure_route_page.title"));
      this.date_picker_lang = newLocale;
      this.date_picker_langKey++;
    },
  },
};
</script>
<style scoped>
.icon-with-text {
  position: relative;
  display: inline-block;
  color: red;
}
.bg-action-bar {
  background: #f6faff;
}

.route-display-container {
  position: relative;
}

.route-compact {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.route-summary-line {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #F9FAFB;
  border-radius: 6px;
  border: 1px solid #E5E7EB;
  transition: all 0.2s ease;
}

.route-display-container:hover .route-summary-line {
  background: #F3F4F6;
  border-color: #D1D5DB;
}

.route-info-text {
  font-size: 12px;
  color: #6B7280;
  font-weight: 500;
}

.route-display {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Popover Styles */
.route-popover {
  position: fixed;
  left: auto;
  top: auto;
  transform: none;
  margin-left: 0px;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.route-display-container:hover .route-popover {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.popover-content {
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 
              0 10px 10px -5px rgba(0, 0, 0, 0.04),
              0 0 0 1px rgba(0, 0, 0, 0.05);
  width: 400px;
  height: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.popover-header {
  padding: 8px 15px;
  border-bottom: 2px solid #E5E7EB;
  background: #FFFFFF;
  position: sticky;
  top: 0;
  z-index: 10;
  flex-shrink: 0;
}

.popover-header h4 {
  font-size: 15px;
  color: #1F2937;
}

.popover-body {
  padding: 16px 20px 20px;
  background: #FAFAFA;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  max-height: 650px;
}

/* Scrollbar styling for popover body */
.popover-body::-webkit-scrollbar {
  width: 8px;
}

.popover-body::-webkit-scrollbar-track {
  background: #F3F4F6;
  border-radius: 4px;
  margin: 4px;
}

.popover-body::-webkit-scrollbar-thumb {
  background: #9CA3AF;
  border-radius: 4px;
  border: 2px solid #F3F4F6;
}

.popover-body::-webkit-scrollbar-thumb:hover {
  background: #6B7280;
}

.text-xxs {
  font-size: 0.65rem;
  line-height: 1rem;
  letter-spacing: 0.025em;
}

.icon-bg {
  background: #3b82f6;
  border-radius: 50%;
  padding: 1px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  width: 14px;
  height: 14px;
}
.left-header{
  position: absolute;
  left: 10px;
  top: 8px;
}
.scheduled-trips-table-container ::v-deep .vgt-responsive, .history-trips-table-container ::v-deep .vgt-responsive {
  min-height: 450px;
}
</style>
